import { useEffect, useState } from "react";
import { HomeworkShell } from "./HomeworkShell";
import { fmtDate } from "./hwApi";
import { hwdApi } from "./HomeworkHome";

const STATUS_LABEL = { draft: "DRAFT", submitted: "WITH SIR", reviewing: "BEING CHECKED", evaluated: "CHECKED",
                       returned_for_correction: "CORRECTIONS", resubmission_requested: "RESUBMIT" };
const STATUS_CLS = { draft: "locked", submitted: "review", reviewing: "review", evaluated: "approved",
                     returned_for_correction: "failed", resubmission_requested: "failed" };

function ListInner() {
  const [subs, setSubs] = useState(null);
  useEffect(() => {
    hwdApi.get("/submissions").then(({ data }) => setSubs(data.submissions)).catch(() => setSubs([]));
  }, []);
  return (
    <div className="tp-wrap" data-testid="hw-list">
      <div className="tp-eyebrow">MY HOMEWORK</div>
      <h1 className="tp-h2" style={{ fontSize: 28 }}>Submissions &amp; evaluations</h1>
      {subs === null && <p className="tp-muted">Loading…</p>}
      {subs && subs.length === 0 && (
        <div className="tp-panel" style={{ marginTop: 14 }} data-testid="hw-list-empty">
          <p className="tp-muted">No homework yet. <a href="/homework/new" style={{ color: "#1d4ed8" }}>Start your first homework</a> — upload your question paper and solved work for personal checking by Pranjal Sir.</p>
        </div>
      )}
      {(subs || []).map((s) => (
        <a key={s.submission_id} href={s.status === "draft" ? `/homework/new?resume=${s.submission_id}` : `/homework/hw/${s.submission_id}`}
           style={{ textDecoration: "none" }} data-testid={`hw-list-${s.submission_id}`}>
          <div className="tp-panel" style={{ marginTop: 12 }}>
            <div className="admin-row" style={{ flexWrap: "wrap", gap: 8 }}>
              <span className={`status-pill ${STATUS_CLS[s.status]}`}>{STATUS_LABEL[s.status]}</span>
              <b style={{ color: "#0b2545", flex: 1 }}>{s.title}</b>
              {s.evaluation && <b style={{ color: "#15803d", fontSize: 17 }} data-testid={`hw-list-score-${s.submission_id}`}>{s.evaluation.score_10}/10</b>}
            </div>
            <p className="tp-muted" style={{ margin: "6px 0 0", fontSize: 12 }}>
              {s.category_label} · {s.chapter} · {s.topic}{s.subtopic ? ` · ${s.subtopic}` : ""} · {s.submitted_at ? `submitted ${fmtDate(s.submitted_at)}` : "draft — not submitted yet"}</p>
          </div>
        </a>
      ))}
      <div className="admin-row" style={{ marginTop: 18, gap: 14 }}>
        <a href="/homework/new" className="tp-btn small" style={{ textDecoration: "none" }} data-testid="hw-list-new">+ New homework</a>
        <a href="/homework/results" className="tp-back" style={{ textDecoration: "none" }} data-testid="hw-list-legacy">Earlier question-bank results →</a>
      </div>
    </div>
  );
}

export default function HomeworkDocList() {
  return <HomeworkShell><ListInner /></HomeworkShell>;
}
